module.exports = __webpack_public_path__ + "static/img/57.62574f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/57.png
// module id = pZCi
// module chunks = 2